export default __webpack_public_path__ + "media/images/icons/icon-search_black-cdafc4d924b4e681eb43367a17260885.png";